/**
 * Service Cobranca (M5 — 2026-05-25). Endpoints CRUD de Boleto +
 * ConfiguracaoCobranca.
 */

const PREFIXO_BOLETO = "/api/boletos";
const PREFIXO_CONFIG = "/api/configuracoes-cobranca";


export function listarBoletos(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.situacao) usp.set("situacao", params.situacao);
  if (params.cliente) usp.set("cliente", params.cliente);
  const qs = usp.toString();
  return request(`${PREFIXO_BOLETO}${qs ? `?${qs}` : ""}`);
}

export function obterBoleto(request, id) {
  return request(`${PREFIXO_BOLETO}/${id}`);
}

export function criarBoleto(request, dados) {
  return request(PREFIXO_BOLETO, { method: "POST", body: JSON.stringify(dados) });
}

export function cancelarBoleto(request, id, motivo = "") {
  return request(`${PREFIXO_BOLETO}/${id}/cancelar`, {
    method: "POST",
    body: JSON.stringify({ motivo }),
  });
}

export function marcarBoletoPago(request, id, { valor_pago, pago_em } = {}) {
  return request(`${PREFIXO_BOLETO}/${id}/marcar-pago`, {
    method: "POST",
    body: JSON.stringify({ valor_pago, pago_em }),
  });
}

export function listarConfiguracoesCobranca(request) {
  return request(PREFIXO_CONFIG);
}

export function criarOuAtualizarConfiguracao(request, dados, id = null) {
  if (id) {
    return request(`${PREFIXO_CONFIG}/${id}`, {
      method: "PATCH", body: JSON.stringify(dados),
    });
  }
  return request(PREFIXO_CONFIG, { method: "POST", body: JSON.stringify(dados) });
}


export const SITUACOES_BOLETO = [
  { value: "PENDENTE", label: "Pendente", tone: "warning" },
  { value: "PAGO", label: "Pago", tone: "success" },
  { value: "VENCIDO", label: "Vencido", tone: "danger" },
  { value: "CANCELADO", label: "Cancelado", tone: "neutral" },
  { value: "ERRO", label: "Erro", tone: "danger" },
];

export const SITUACAO_BOLETO_TONES = Object.fromEntries(
  SITUACOES_BOLETO.map((s) => [s.value, s.tone])
);
export const SITUACAO_BOLETO_LABELS = Object.fromEntries(
  SITUACOES_BOLETO.map((s) => [s.value, s.label])
);
